module.exports = __webpack_public_path__ + "img/about1.271ac8d1.svg";